<section class="page-container bg-primary">

    <div class="container h-100">

        <div class="row h-100 d-flex justify-content-center align-items-center">

            <div class="col-md-8">

                <a class="btn btn-link text-white ml-1 pb-4" [routerLink]="[ data.URL_HOME ] | localize"><i
                        class="fas fa-arrow-left fa-2x"></i></a>

                <nav class="navbar navbar-dark bg-primary">

                    <a class="navbar-brand d-flex align-items-center" [routerLink]="[ data.URL_HOME ] | localize">
                        <img class="logo" src="./assets/imagens/logo_branca.png">
                    </a>

                    <div id="navbarNav" class="d-flex justify-content-end">

                        <ul>
                            <li class="drop-down">
                                <a><i class="flag-icon {{ idiomaSelecionado.FLAG }} mr-lg-2"></i><span
                                        class="d-none d-lg-inline">{{ idiomaSelecionado.TITULO }}</span><i
                                        class="fas fa-angle-down ml-2"></i></a>
                                <ul>
                                    <li *ngFor="let idioma of idiomas">
                                        <a *ngIf="idiomaSelecionado.CODIGO != idioma.CODIGO" (click)="alterarIdioma(idioma.CODIGO)"><i
                                                class="flag-icon {{ idioma.FLAG }} mr-2"></i>{{ idioma.TITULO }}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>

                    </div>

                </nav>

                <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" action="{{ urlLogin }}" method="POST" accept-charset="ISO-8859-1" #form>

                    <div class="col-md-12 mt-4">

                        <h3 class="text-white"> {{ data.TITLE }} </h3>
                        <p class="text-white"> {{ data.DESCRICAO }} </p>

                        <div class="control-group mb-2">

                            <div class="form-group">

                                <label class="text-white control-label">{{ data.CAMPO_EMPRESA }} <span
                                        class="text-warning">*</span></label>
                                <div class="input-group mb-0">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-building"></i></span>
                                    </div>
                                    <input type="text" class="form-control" name="nomeEmpresa"
                                        formControlName="formNomeEmpresa">
                                </div>

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.NOME_EMPRESA">
                                    <span class="text-warning"
                                        *ngIf="formGroup.get('formNomeEmpresa').hasError(validator.TYPE) && (formGroup.get('formNomeEmpresa').dirty || formGroup.get('formNomeEmpresa').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>

                        </div>

                        <div class="control-group mb-2">

                            <div class="form-group">

                                <label class="text-white control-label">{{ data.CAMPO_USUARIO }} <span
                                        class="text-warning">*</span></label>
                                <div class="input-group mb-0">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-user"></i></span>
                                    </div>
                                    <input type="text" class="form-control" name="usuario"
                                        formControlName="formUsuario">
                                </div>

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.USUARIO">
                                    <span class="text-warning"
                                        *ngIf="formGroup.get('formUsuario').hasError(validator.TYPE) && (formGroup.get('formUsuario').dirty || formGroup.get('formUsuario').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>

                        </div>

                        <div class="control-group mb-4">

                            <div class="form-group">

                                <label class="text-white control-label">{{ data.CAMPO_SENHA }} <span
                                        class="text-warning">*</span></label>
                                <div class="input-group mb-0">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-lock"></i></span>
                                    </div>
                                    <input type="password" class="form-control" name="senha"
                                        formControlName="formSenha">
                                </div>

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.SENHA">
                                    <span class="text-warning"
                                        *ngIf="formGroup.get('formSenha').hasError(validator.TYPE) && (formGroup.get('formSenha').dirty || formGroup.get('formSenha').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>

                        </div>

                        <div class="form-group">
                            <button type="submit" class="btn btn-info rounded-0 w-100" [disabled]="!formGroup.valid"
                                (click)="form.submit()">
                                <i class="fas fa-sign-in-alt mr-2"></i>
                                {{ data.BOTAO }}
                            </button>
                        </div>

                        <div class="form-group d-flex align-items-center justify-content-center mb-0">
                            <span class="text-white mr-1">{{ data.DESCRICAO_CADASTRO }}</span>
                            <a class="btn btn-link text-white p-0"
                                [routerLink]="[ data.URL_CADASTRO ] | localize">{{ data.CADASTRO }}</a>
                        </div>

                        <div class="form-group text-center">
                            <a class="btn btn-link text-white p-0"
                                [routerLink]="[ data.URL_ESQUECEU ] | localize">{{ data.ESQUECEU_SENHA }}</a>
                        </div>

                    </div>

                    <input type="hidden" name="angular" value="true" />
                    <input type="hidden" name="language" value="{{ languageParam }}" />

                </form>

            </div>

        </div>

    </div>

</section>